import { Box, BoxProps } from "@mui/material";

/**
 * Indents the fields a checkbox discloses so they line up under its label
 * rather than the checkbox itself. Used by both disclosures on the reporting
 * facility chemical dialog (the exemption reason/note and the staff
 * reporting-unit override) so the two cannot drift apart.
 *
 * `pl` rather than `ml`: this renders inside a spaced MUI `Stack`, which sets
 * `margin: 0` on its children and would silently flatten a margin here.
 */
export function DisclosurePanel({ children, sx, ...rest }: BoxProps) {
  return (
    <Box
      {...rest}
      sx={[
        {
          display: "flex",
          flexDirection: "column",
          pl: 4,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
}
